import { FilterByColumnQuery, numberFilterCondition } from '.'
import { getQFromQuery } from '../../utils'
import { FilterText, FilterTypes } from '../types'

export const generateQuery = ({
  sourceDataset,
  sourceColumn,
  filterType,
  filterTextType,
  filterNumberType,
  filterNumberFirst,
  filterNumberSecond,
  filterValue,
  withAs,
  from
}: FilterByColumnQuery) => {
  let where = ''
  const nextQNumber = getQFromQuery(withAs) + 1
  if (filterType === FilterTypes.Text && filterValue) {
    // replacing / with \/ in order to be able to search dates within a string column (e.g. '10/04/2020')
    // eslint-disable-next-line no-useless-escape
    const values = filterValue.map((v) => `${v.replaceAll('/', '\\/')}`).join('|')
    const operator = filterTextType === FilterText.Equal ? '~*' : '!~*'
    where = `${sourceColumn} ${operator} '${values}'`
  } else {
    where = numberFilterCondition({
      provider: sourceDataset?.providerId,
      sourceColumn,
      filterNumberType,
      filterNumberFirst,
      filterNumberSecond
    })
  }
  return where && from
    ? `${withAs},
__q${nextQNumber} AS (
\tSELECT * FROM ${from} WHERE ${where}
)
SELECT * FROM __q${nextQNumber}`
    : ''
}
